import { render, staticRenderFns } from "./ConTab.vue?vue&type=template&id=37af0769&scoped=true"
import script from "./ConTab.vue?vue&type=script&lang=js"
export * from "./ConTab.vue?vue&type=script&lang=js"
import style0 from "./ConTab.vue?vue&type=style&index=0&id=37af0769&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af0769",
  null
  
)

export default component.exports